import { ShaderFactory } from "./types"
import { Unit } from "../types"

type ShaderProps = {
    release?: boolean
}

const useTypeWriter: ShaderFactory<ShaderProps> = ({ release = true } = {}) => {
    return (input, tick) => {
        let offset = 0
        return input.map((row, y) => {
            return row.map((unit: Unit, x) => {
                offset++
                if (offset < tick && release) return unit
                return ' '
            })
        })
    }
}

export default useTypeWriter
